<template>
  <Modal v-if="Boolean(mode)" :show="true" @close="mode = null" class="task-modal">
    <Mutate
      v-if="mode === 'mutate'"
      :default-data="defaultData"
      :id="id"
      theme="flat"
      @onUpdate="onUpdate"
      @onRemove="onRemove"
    >
      <template #footer>
        <ButtonComponent :label="$t('cancel')" @click="id ? (mode = 'view') : (mode = null)" :icon="['fal', 'times']" />
      </template>
    </Mutate>
    <ViewComponent
      v-if="mode === 'view'"
      v-bind="options.props"
      :id="id"
      @onRemove="onRemove"
      @mutate="mode = 'mutate'"
      @close="mode = null"
    />
  </Modal>
</template>

<script>
import Bus from '@/bus'

import { ModalComponent as Modal } from 'vue-elder-modal'
import Views from './Views'

export default {
  watch: {
    '$route.query.task': {
      handler(val) {
        if (!val) return (this.mode = null)

        this.mode = 'view'
      },
      immediate: true,
    },
    mode(val) {
      if (val || !this.$route.query.task) return

      if (this.callback) this.callback(this.$store.state.Task.item)
      this.$router.replace({ query: { ...this.$route.query, task: undefined } })
    },
  },
  data() {
    return {
      mode: null,
      callback: null,
      defaultData: null,
      options: {},
    }
  },
  computed: {
    id: {
      get() {
        return this.$route.query['task']
      },
      set(val) {
        this.$router.replace({
          query: {
            ...this.$route.query,
            task: val,
          },
        })
      },
    },
  },
  methods: {
    onRemove() {
      this.$store.commit('Task/set', {})
      this.mode = null
    },
    onUpdate(item) {
      if (!item) return (this.mode = null)
      if (!this.id) this.id = item.id
      this.mode = 'view'
    },
  },
  created() {
    Bus.$on('task', (data = {}, cb) => {
      let { id, options = {}, ...defaultData } = data
      this.callback = cb
      this.options = options
      this.mode = id ? 'view' : 'mutate'
      this.defaultData = defaultData

      if (!id || this.$route.query.task === id) return
      this.id = id
    })
  },
  components: {
    Modal,
    Mutate: Views.Mutate,
    ViewComponent: Views.Default,
  },
}
</script>

<style lang="scss">
.task-modal {
}
</style>
